import { client } from '@platform/http/api-client';

// Kanban board CONFIG CRUD. The board's live data (cards, columns, drags) is
// assembled on the client from the shared jira api (searchIssues / getStatuses /
// getIssueTransitions / transitionIssue) — see KanbanBoards.jsx.
const kanbanApi = {
  async getKanbanBoards() {
    return (await client.get('/api/kanban/boards')).data;
  },
  async getKanbanBoard(id) {
    return (await client.get(`/api/kanban/boards/${id}`)).data;
  },
  async createKanbanBoard(data) {
    return (await client.post('/api/kanban/boards', data)).data;
  },
  async updateKanbanBoard(id, data) {
    return (await client.put(`/api/kanban/boards/${id}`, data)).data;
  },
  async deleteKanbanBoard(id) {
    return (await client.delete(`/api/kanban/boards/${id}`)).data;
  },
};

export default kanbanApi;
